import { whatWeDoCards } from "views/components/pages/PharmacyAI/constants";
import { PageContainer } from "views/components/pages/PharmacyAI/layout";
import {
  BenefitCard,
  BenefitCards,
  WhatWeDoCopy,
  WhatWeDoGrid,
  WhatWeDoSection,
} from "./styles";

const WhatWeDo = () => {
  return (
    <WhatWeDoSection>
      <PageContainer>
        <WhatWeDoGrid>
        <WhatWeDoCopy>
          <p className="eyebrow">What does Taskgo do?</p>
          <h2>Save Pharmacist&apos;s Hours Whilst Scaling Patient Care</h2>
          <p className="subtitle">
            AI assistants to improve the patient journey and maximise every
            pharmacist&apos;s skill set.
          </p>
        </WhatWeDoCopy>

        <BenefitCards>
          {whatWeDoCards.map((card, index) => (
            <BenefitCard key={card.title}>
              <span className="icon" aria-hidden>
                {index + 1}
              </span>
              <div>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </BenefitCard>
          ))}
        </BenefitCards>
        </WhatWeDoGrid>
      </PageContainer>
    </WhatWeDoSection>
  );
};

export default WhatWeDo;
